<template>
	<AppScreen class="ending-view" :scrollable="false">
		<Enzo
			ref="enzo"
			v-bind="$attrs"
			:buttons="[{ text: button_text, action: next }]"
		/>
	</AppScreen>
</template>

<script>
import AppScreen from '@/components/partials/AppScreen';
import Enzo from '@/components/partials/Enzo';

export default {
	name: 'EnzoFiring',
	components: {
		AppScreen,
		Enzo,
	},
	props: {
		button_text: {
			type: String,
			required: true,
		},
	},
	methods: {
		next() {
			this.$refs.enzo.pushState('exiting', () => this.$router.push('/postgame'));
		},
	},
};
</script>

<style lang="scss" scoped>
	.ending-view {
		height: 100%;
		width: 100%;
		align-items: center;
		background-image: url('~@/assets/images/curtain-background.png');
		background-position: right top;
		background-repeat: repeat-x;
		background-size: auto 100%;
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		justify-content: space-between;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/EnzoFiring.vue